import React from 'react';
import { Box, ButtonBase, CircularProgress, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

const rowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  '&:hover': {
    backgroundColor: theme => alpha(theme.palette.primary.main, 0.14),
    color: theme => theme.palette.primary.main
  },
  '&:hover .MuiTypography-root': {
    textDecoration: 'underline',
    textUnderlineOffset: '4px'
  },
  p: 2
};

// While busy, the icon and label keep their place but turn invisible, so the row does not change
// size, and the spinner takes the icon's spot.
const busyRowSx = {
  position: 'relative',
  '& > :not(.MuiCircularProgress-root)': { visibility: 'hidden' },
};

/**
 * A row of the mobile menu. With `to` it is a link, and `onClick`, if given, runs on the way.
 * With `onClick` but no `to` it is an action, which shows a spinner while `busy`.
 */
const MenuItem = ({ to, label, icon = null, componentType: Component = NavLink, onClick, busy = false }) => {

  if (onClick && !to) {
    return (
      <ButtonBase
        onClick={onClick}
        // Enter and Space would also reach the drawer's own key handler, which closes it before
        // the spinner can be seen.
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.stopPropagation();
          }
        }}
        disabled={busy}
        aria-busy={busy}
        // Busy, the label is hidden and names nothing; this keeps the row named.
        aria-label={label}
        disableRipple
        sx={{ display: 'block', width: '100%', textAlign: 'left', color: 'inherit' }}
      >
        <Box sx={{ ...rowSx, ...(busy && busyRowSx) }}>
          {icon}
          <Typography>
            {label}
          </Typography>
          {busy && <CircularProgress size={20} color="inherit" sx={{ position: 'absolute', left: 16 }} />}
        </Box>
      </ButtonBase>
    );
  }

  return (
    <Component
      to={to}
      onClick={onClick}
      style={{ textDecoration: 'none', color: "inherit" }}
    >
      <Box sx={rowSx}>
        {icon}
        <Typography >
          {label}
        </Typography>
      </Box>
    </Component>
  );
};

export default MenuItem;
